export default [
  // Партнеры
  {
    name: 'Partners.Organizations',
    path: 'list',
    component: () => import('./components/organizations/List')
  },
  {
    name: 'Partners.Organizations.Edit',
    path: 'list/:id?/edit',
    props: true,
    component: () => import('./components/organizations/Edit')
  },
  {
    name: 'Partners.Organizations.Offices.Edit',
    path: 'list/:organizationId/offices/:id?/edit',
    props: true,
    component: () => import('./components/offices/Edit')
  },
  {
    name: 'Partners.Organizations.Users.Edit',
    path: 'list/:organizationId/users/:id?/edit',
    props: true,
    component: () => import('./components/users/Edit')
  },
  // Акции
  {
    name: 'Partners.Actions',
    path: 'actions',
    component: () => import('./components/actions/List')
  },
  {
    name: 'Partners.Actions.Show',
    path: 'actions/:id?',
    props: true,
    component: () => import('./components/actions/Show')
  }
]
